export function formatFiatCurrency(value: number): string {
  if (
    value == undefined ||
    value == null ||
    isNaN(value) ||
    !isFinite(value) ||
    value === 0
  ) {
    return "0";
  }
  const fixed = (+value).toFixed(4).replace(/\.?0+$/, "");
  const [intPart, decPart] = fixed.split(".");

  // Добавляем пробелы только в целой части
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return decPart ? `${formattedInt}.${decPart}` : formattedInt;
}

export function formatCryptoCurrency(value: number): string {
  if (
    value == undefined ||
    value == null ||
    isNaN(value) ||
    !isFinite(value) ||
    value === 0
  ) {
    return "0";
  }
  let str = (+value).toFixed(9);
  str = str.substring(0, str.length - 1).replace(/\.?0+$/, "");
  return str;
}

export function formatAmountByPrecision(
  value: number,
  precision: number
): string {
  if (value == undefined || value == null || isNaN(value) || !isFinite(value)) {
    return "0" + (precision > 0 ? "." + "0".repeat(precision) : "");
  }

  return (+value).toFixed(precision);
}
